import type { ReactElement } from "react";
import { CONTAINER_BOTTOM_PADDING, CONTAINER_HORIZONTAL_PADDING, CONTAINER_TOP_PADDING, SCROLL_FADE_COLOR, SCROLL_FADE_WIDTH, } from "./kanban-view-constants";
export enum KanbanScrollFadeSide {
    Left = "left",
    Right = "right"
}
interface KanbanScrollFadeProps {
    side: KanbanScrollFadeSide;
}
export function KanbanScrollFade({ side, }: KanbanScrollFadeProps): ReactElement {
    const isLeft = side === KanbanScrollFadeSide.Left;
    return (
      <div aria-hidden="true" style={{
            position: "absolute",
            top: CONTAINER_TOP_PADDING,
            bottom: CONTAINER_BOTTOM_PADDING,
            left: isLeft ? CONTAINER_HORIZONTAL_PADDING : undefined,
            right: isLeft ? undefined : CONTAINER_HORIZONTAL_PADDING,
            width: SCROLL_FADE_WIDTH,
            backgroundImage: `linear-gradient(to ${isLeft ? "right" : "left"}, ${SCROLL_FADE_COLOR}, transparent)`,
            pointerEvents: "none",
            zIndex: 1,
        }}/>
    );
}
